(function (window, document) {

  var viewport = (function () {
    var height;

    if (typeof window.innerWidth !== 'undefined') {
      // the more standards compliant browsers (mozilla/netscape/opera/IE7) use window.innerWidth and window.innerHeight
      height = window.innerHeight
    } else if (typeof document.documentElement !== 'undefined'
      && typeof document.documentElement.clientWidth !== 'undefined'
      && document.documentElement.clientWidth !== 0) {
      // IE6 in standards compliant mode (i.e. with a valid doctype as the first line in the document)
      height = document.documentElement.clientHeight
    } else {
      // older versions of IE
      height = document.getElementsByTagName('body')[0].clientHeight
    }

    return {
      height: height
    }
  })();

  var threeshold = Math.round(Math.max(300, viewport.height / 2));

  var _observer;

  var _elements;

  var runningOnBrowser = typeof window !== "undefined";

  var isBot = runningOnBrowser && !("onscroll" in window) || /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent);

  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  function eventHandler(event, success) {
    var element = event.target;

    element.classList.remove('loading');
    element.classList.add(success ? 'loaded' : 'error');

    // callback
    if (success && 'function' === typeof window.picturefill) {
      window.picturefill({
        reevaluate: true,
        elements: element
      });
    }

    element.removeEventListener('load', loadHandler);
    element.removeEventListener('loadeddata', loadHandler);
    element.removeEventListener('error', errorHandler);
  }

  function loadHandler(event) {
    eventHandler(event, true);
  }

  function errorHandler(event) {
    eventHandler(event, false);
  }

  function revealElement(element) {
    if ('true' === element.getAttribute('data-was-processed')) {
      return;
    }

    element.addEventListener('load', loadHandler);
    element.addEventListener('loadeddata', loadHandler);
    element.addEventListener('error', errorHandler);

    element.classList.add('loading');

    // picture
    var parentElement = element.parentNode;
    if (parentElement && 'PICTURE' === parentElement.tagName) {
      for (var i = 0, source; source = parentElement.children[i]; i += 1) {
        if ('SOURCE' !== source.tagName) {
          continue;
        }

        // picture/source[srcset]
        var attrValue = source.getAttribute('data-srcset');
        setAttributeIfValue(source, 'srcset', attrValue);
      }
    }

    // img[sizes]
    var sizesDataValue = element.getAttribute('data-sizes');
    setAttributeIfValue(element, 'sizes', sizesDataValue);

    // img[srcset]
    var srcsetDataValue = element.getAttribute('data-srcset');
    setAttributeIfValue(element, 'srcset', srcsetDataValue);

    // img[src]
    var srcDataValue = element.getAttribute('data-src');
    setAttributeIfValue(element, 'src', srcDataValue);

    element.setAttribute('data-was-processed', 'true');
  }

  function setAttributeIfValue(element, attrName, value) {
    if (!value) {
      return;
    }
    element.setAttribute(attrName, value);
  }

  function loadAll() {
    _elements.forEach(function (element) {
      revealElement(element);
    })
  }

  function isIntersecting(entry) {
    return entry.isIntersecting || entry.intersectionRatio > 0;
  }

  function _manageIntersection(entry) {

    if (isIntersecting(entry)) {
      var element = entry.target;
      revealElement(element);
      _observer.unobserve(element);
    }
  }

  function _onIntersection(entries) {
    entries.forEach(_manageIntersection);
  }

  function _setObserver() {
    if (!("IntersectionObserver" in window)) {
      return;
    }

    _observer = new IntersectionObserver(_onIntersection, {
      root: null,
      rootMargin: threeshold + 'px ' + threeshold + 'px ' + threeshold + 'px ' + threeshold + 'px'
    });
  }

  function update(elements) {
    _elements = elements || document.querySelectorAll('img[data-spy="lazyload"]');

    // filter processed
    _elements = Array.prototype.slice.call(_elements);
    _elements = _elements.filter(function (element) {
      return !('true' === element.getAttribute('data-was-processed'))
    });

    if (isBot || !_observer) {
      loadAll();
      return;
    }

    _elements.forEach(function (element) {
      _observer.observe(element);
    });
  }

  _setObserver();
  update();

  // print
  if (isSafari) {
    var mediaQueryList = window.matchMedia('print');
    mediaQueryList.addListener(function (mediaQuery) {
      if (mediaQuery.matches) {
        loadAll();
      }
    });
  } else {
    window.addEventListener('beforeprint', function (event) {
      loadAll();
    })
  }

  window.lazyLoadInstance = {
    update: update
  }

})(window, document);
